/* HVAC-073-DI */

(function () {
  var GROUP_ORDER = ['tonnage', 'cabinet', 'configuration', 'efficiency'];

  function parseTonnage(text) {
    var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*(?:ton)?/i);
    return match ? match[1] : '';
  }

  function groupKind(group) {
    if (group.classList.contains('custom-variant-selector__group--tonnage')) return 'tonnage';
    if (group.classList.contains('custom-variant-selector__group--cabinet')) return 'cabinet';
    if (group.classList.contains('custom-variant-selector__group--configuration')) return 'configuration';
    if (group.classList.contains('custom-variant-selector__group--efficiency')) return 'efficiency';

    var label = group.querySelector('.custom-variant-selector__label');
    var text = label ? label.textContent.toLowerCase() : '';
    if (text.indexOf('tonnage') !== -1) return 'tonnage';
    if (text.indexOf('cabinet') !== -1 || text.indexOf('width') !== -1) return 'cabinet';
    if (text.indexOf('configuration') !== -1) return 'configuration';
    if (text.indexOf('efficiency') !== -1 || text.indexOf('seer') !== -1) return 'efficiency';
    return '';
  }

  function wrapHeader(group) {
    var label = group.querySelector('.custom-variant-selector__label');
    if (!label || label.parentElement.classList.contains('custom-variant-selector__header')) return label;
    var header = document.createElement('div');
    header.className = 'custom-variant-selector__header';
    label.parentNode.insertBefore(header, label);
    header.appendChild(label);
    return label;
  }

  function addSubtitle(group, text) {
    if (!text || group.querySelector('.custom-variant-selector__subtitle')) return;
    var label = wrapHeader(group);
    if (!label) return;
    var subtitle = document.createElement('p');
    subtitle.className = 'custom-variant-selector__subtitle';
    subtitle.textContent = text;
    label.after(subtitle);
  }

  function addCoverage(group, data) {
    group.querySelectorAll('.custom-variant-selector__option').forEach(function (option) {
      if (option.querySelector('.custom-variant-selector__coverage')) return;

      var raw = option.getAttribute('data-option-value') || option.textContent;
      option.setAttribute('data-option-value', raw.trim());

      var tonnage = parseTonnage(raw);
      var coverage = data.coverage[tonnage] || data.coverage[parseFloat(tonnage)];
      var label = document.createElement('span');
      label.className = 'custom-variant-selector__option-label';
      label.textContent = raw.trim();

      option.textContent = '';
      option.appendChild(label);

      if (coverage) {
        var line = document.createElement('span');
        line.className = 'custom-variant-selector__coverage';
        line.textContent = coverage;
        option.appendChild(line);
      }
    });
  }

  function addDisclaimer(group, text) {
    if (!text || group.querySelector('.custom-variant-selector__disclaimer')) return;
    var note = document.createElement('p');
    note.className = 'custom-variant-selector__disclaimer';
    note.textContent = text;
    group.appendChild(note);
  }

  function injectTemplate(group, templateId) {
    if (group.querySelector('.pdp-v2-infographic')) return;
    var template = document.getElementById(templateId);
    if (!template || !template.content) return;
    group.appendChild(template.content.cloneNode(true));
  }

  function reorderGroups(selector) {
    var groups = Array.prototype.filter.call(selector.children, function (el) {
      return el.classList && el.classList.contains('custom-variant-selector__group');
    });
    if (groups.length < 2) return;

    var byKind = {};
    var leftover = [];
    groups.forEach(function (group) {
      var kind = groupKind(group);
      if (kind && !byKind[kind]) {
        byKind[kind] = group;
      } else {
        leftover.push(group);
      }
    });

    GROUP_ORDER.forEach(function (kind) {
      if (byKind[kind]) selector.appendChild(byKind[kind]);
    });
    leftover.forEach(function (group) {
      selector.appendChild(group);
    });
  }

  function enhance(selector, data) {
    if (selector.dataset.infographicsReady === 'true') return;
    var groups = selector.querySelectorAll('.custom-variant-selector__group');
    if (!groups.length) return;

    selector.dataset.infographicsReady = 'true';

    groups.forEach(function (group) {
      var kind = groupKind(group);
      if (kind && !group.classList.contains('custom-variant-selector__group--' + kind)) {
        group.classList.add('custom-variant-selector__group--' + kind);
      }

      if (kind === 'tonnage') {
        addSubtitle(group, data.subtitleTonnage);
        addCoverage(group, data);
        addDisclaimer(group, data.disclaimer);
      } else if (kind === 'cabinet') {
        addSubtitle(group, data.subtitleCabinet);
        injectTemplate(group, 'pdp-v2-infographic-cabinet-tpl');
      } else if (kind === 'configuration') {
        addSubtitle(group, data.subtitleConfiguration);
        injectTemplate(group, 'pdp-v2-infographic-config-tpl');
        var hasMulti = Array.prototype.some.call(
          group.querySelectorAll('.custom-variant-selector__option'),
          function (option) {
            return /multi/i.test(option.textContent);
          }
        );
        var multiRow = group.querySelector('.pdp-v2-infographic__item--multi');
        if (multiRow && !hasMulti) {
          multiRow.hidden = true;
        }
      }
    });

    reorderGroups(selector);
  }

  function readData(root) {
    var coverage = {};
    var coverageEl = document.getElementById('pdp-v2-infographic-coverage');
    if (coverageEl) {
      try {
        coverage = JSON.parse(coverageEl.textContent);
      } catch (err) {
        coverage = {};
      }
    }
    return {
      subtitleTonnage: root.dataset.subtitleTonnage || '',
      subtitleCabinet: root.dataset.subtitleCabinet || '',
      subtitleConfiguration: root.dataset.subtitleConfiguration || '',
      disclaimer: root.dataset.disclaimer || '',
      coverage: coverage
    };
  }

  function watchSelector(selector, data) {
    if (selector.querySelector('.custom-variant-selector__group')) {
      enhance(selector, data);
      return;
    }

    var observer = new MutationObserver(function () {
      if (selector.querySelector('.custom-variant-selector__group')) {
        observer.disconnect();
        enhance(selector, data);
      }
    });
    observer.observe(selector, { childList: true, subtree: true });
  }

  function init() {
    var root = document.querySelector('.pdp-v2-selector-infographics');
    if (!root) return;
    var data = readData(root);

    document.querySelectorAll('.custom-variant-selector--ac-coil').forEach(function (selector) {
      watchSelector(selector, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
